import { render, staticRenderFns } from "./assetmutationfrm.vue?vue&type=template&id=8b74bc42"
import script from "./assetmutationfrm.vue?vue&type=script&lang=js"
export * from "./assetmutationfrm.vue?vue&type=script&lang=js"
import style0 from "./assetmutationfrm.vue?vue&type=style&index=0&id=8b74bc42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports